import { Injectable } from '@angular/core';
import { LoginInputsModel } from '../../auth/models/login-inputs.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { LoginSuccessModel } from '../../auth/models/login-success.model';
import { RegisterInputsModel } from '../../auth/models/register-inputs.model';
import { CheckHandleInput } from '../input/check-handle.input';
import { Apollo } from 'apollo-angular';
import { CheckHandleResponse } from '../response/check-handle.response';
import { checkHandleQuery } from '../gql/check-handle.query';
import { ApolloQueryResult } from 'apollo-client';
import { ForgotPasswordInput } from '../../shared/data/inputs/forgot-password.input';
import { ForgotPasswordResponse } from '../../shared/data/responses/forgot-password.response';
import { forgotPasswordMutation } from '../../shared/data/gql/mutation/forgot-password.mutation';
import { FetchResult } from 'apollo-link';
import { VerifyOtpInput } from '../../shared/data/inputs/verify-otp.input';
import { VerifyOtpResponse } from '../../shared/data/responses/verify-otp.response';
import { verifyOtpMutation } from '../../shared/data/gql/mutation/verify-otp.mutation';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private httpClient: HttpClient, private apollo: Apollo) {}

  userLogin(input: LoginInputsModel): Observable<LoginSuccessModel> {
    return this.httpClient.post<LoginSuccessModel>(
      environment.BASE_URL + '/auth/login',
      input
    );
  }

  registerUser(input: RegisterInputsModel): Observable<any> {
    return this.httpClient.post(environment.BASE_URL + '/auth/register', input);
  }

  refreshToken(token: string): Observable<LoginSuccessModel> {
    return this.httpClient.get<LoginSuccessModel>(
      environment.BASE_URL + '/auth/refresh_token',
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
  }

  socialLogin(params: {}): Observable<string> {
    return this.httpClient.get<string>(
      'https://api.gscroll.com/auth/google/callback',
      { params: params }
    );
  }

  checkHandle(
    input: CheckHandleInput
  ): Observable<ApolloQueryResult<CheckHandleResponse>> {
    return this.apollo.query<CheckHandleResponse>({
      query: checkHandleQuery,
      variables: input
    });
  }

  forgotPassword(
    input: ForgotPasswordInput
  ): Observable<FetchResult<ForgotPasswordResponse>> {
    return this.apollo.mutate<ForgotPasswordResponse>({
      mutation: forgotPasswordMutation,
      variables: input
    });
  }

  verifyOTP(input: VerifyOtpInput): Observable<FetchResult<VerifyOtpResponse>> {
    return this.apollo.mutate<VerifyOtpResponse>({
      mutation: verifyOtpMutation,
      variables: input
    });
  }
}
